import BillingsOrderTaxiRailyAddRequest, {
  BillingsOrderTaxiRailyAddRequestBody,
} from "./billings-order-taxi-raily-add.request";

const createBody = (
  request: BillingsOrderTaxiRailyAddRequest,
): BillingsOrderTaxiRailyAddRequestBody => {
  return {
    billingNodes: request.billingNodes,
    billingType: request.billingType,
    discount: request.discount,
  };
};

const billingsOrderTaxiRailyAddRequestFactory = {
  createBody,
};

export default billingsOrderTaxiRailyAddRequestFactory;
